import { FC } from "react";
import classNames from "classnames";

import { convertStringToSlug } from "utils";

import s from "./Pretitle.module.scss";

interface Props {
  pretitle?: string;
  title?: string;
  small?: boolean;
}

export const Pretitle: FC<Props> = ({ pretitle, title, small }) => (
  <div>
    {pretitle && <p className={s.Pretitle}>{pretitle}</p>}
    {title && !small ? (
      <h2 id={convertStringToSlug(title)} className={classNames(s.Title)}>
        {title}
      </h2>
    ) : (
      title && (
        <h3 id={convertStringToSlug(title)} className={classNames(s.Title)}>
          {title}
        </h3>
      )
    )}
  </div>
);
